import useRoleContext from 'app/KinerjaShared/hooks/useRoleContext'

import type { FC } from 'react'

interface PageGuardDinasProps extends React.HTMLAttributes<HTMLDivElement> {}

const PageGuardDinas: FC<PageGuardDinasProps> = ({ children }) => {
  const { isLoading: isLoadingRole, isKepalaDinas, leave } = useRoleContext()

  // If the user is not kepala dinas, redirect to 404 page
  if (!isLoadingRole && !isKepalaDinas) leave()

  // As the component should not be rendered when still loading the user role, we can just return null
  if (isLoadingRole) return null

  return <>{children}</>
}

export default PageGuardDinas
